import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { stage } from "../../assets/globalHelpers";
import "../../assets/css/argon-dashboard-react.css"
import "../../assets/css/diagramms/arrayDiagram.css"
import { stagesNames } from "../translation.js"
import { useLanguage } from "context/LanguageProvider";
import { useDarkMode } from "context/DarkModeProvider";
import axiosInstance from "apiHandles/axiosInstance"; // ✅ Πρόσθεσε

function ArrayDiagram({ items, finalStages, onItemClick }) {
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { darkMode } = useDarkMode();
  const { selLanguage, toggleLanguage, isLoading } = useLanguage();

  const colorScheme = {
    primary: '#ec4899',
    secondary: '#db2777',
    accent: '#fce7f3'
  };

  const handleItemClick = (index) => {
    if (onItemClick) {
      onItemClick(index);
      return;
    }

    const stage = finalStages[index];
    if (!stage) {
      console.error("No stage found at index:", index);
      return;
    }

    // ✅ Αποθηκεύουμε ΜΟΝΟ το ID
    localStorage.setItem("stageLocation", stage.name);
    localStorage.setItem("selectedStageId", stage.id);  // ✅ Μόνο ID

    navigate("/admin/index");
  };

  return (
    <div className="arrayDiagramContainer">
      <div className="arrayDiagramSpace">
        {items.map((item, index) => (
          <div
            key={index}
            className="arrayItem"
            style={{
              borderRight: index !== items.length - 1 ? `2px solid ${colorScheme.primary}` : "none",
            }}
          >
            <div
              className="arrayItemBox"
              style={{
                background: `linear-gradient(135deg, ${colorScheme.primary}15 0%, ${colorScheme.secondary}10 100%)`,
                backdropFilter: 'blur(10px)',
                color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
                border: `1px solid ${colorScheme.primary}30`,
                transform: hoveredIndex === index ? "translateY(-4px) scale(1.02)" : "translateY(0) scale(1)",
                boxShadow: hoveredIndex === index
                  ? `0 12px 25px -5px ${colorScheme.primary}40, 0 0 0 1px ${colorScheme.primary}20`
                  : `none`,
                cursor: 'pointer',
              }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => handleItemClick(index)}
            >
              {selLanguage ? stagesNames[item.toLowerCase()] : item}
            </div>
          </div>
        ))}
      </div>

      <div className="arrayIndexContainer">
        {items.map((_, index) => (
          <div
            key={index}
            className="arrayIndex"
            style={{
              color: darkMode ? "var(--commonWhite)" : colorScheme.primary,
              fontWeight: hoveredIndex === index ? "bold" : "normal",
            }}
          >
            [{index}]
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArrayDiagram;